import { useState, type ReactNode, type ComponentPropsWithoutRef } from "react";
import { FormattedMessage } from "react-intl";

import ActionButton from "common/core/action_button";
import Button from "common/core/button";
import Icon from "common/core/icon";
import { MultipartFormRow } from "common/core/form/layout";

import Styles from "./form.module.scss";

type Props = ComponentPropsWithoutRef<typeof Button> & {
  onBack?: () => void;
};

export function Actions({ onBack, ...buttonProps }: Props) {
  return (
    <footer className={Styles.actions}>
      {onBack && (
        <ActionButton onClick={onBack}>
          <Icon name="caret-left" />
          <FormattedMessage id="9cdadb0d-b2c9-48ac-9122-fb71a7cbf2e8" defaultMessage="Back" />
        </ActionButton>
      )}
      <Button
        buttonColor="action"
        variant="primary"
        type="submit"
        automationId="submit-witness-info"
        {...buttonProps}
      />
    </footer>
  );
}

export function Form(props: ComponentPropsWithoutRef<"form">) {
  return <form className={Styles.form} {...props} />;
}

export function Fields(props: ComponentPropsWithoutRef<"div">) {
  return <div className={Styles.fields} {...props} />;
}

export function CheckboxContainer({ children }: { children: ReactNode }) {
  return <div className={Styles.checkboxContainer}>{children}</div>;
}

export function usePromiseSubmitLock<FV extends Record<string, unknown>>(
  onSubmit: (formValues: FV) => Promise<unknown>,
) {
  const [loading, setLoading] = useState(false);
  return [
    loading,
    (formValues: FV) => {
      setLoading(true);
      return onSubmit(formValues).catch(() => {
        setLoading(false);
      });
    },
  ] as const;
}

export function SpacedMultipartFormRow({ children }: { children: ReactNode }) {
  return <MultipartFormRow className={Styles.spacedRow}>{children}</MultipartFormRow>;
}

export function Subheader({ children }: { children: ReactNode }) {
  return <h5 className={Styles.subheader}>{children}</h5>;
}
